import { useMemo } from 'react';

import useDashboardWidgets from '@/features/dashboard/hooks/useDashboardWidgets';

import { DEFAULT_HSL_BUSES_CONFIG, mergeHslBusesConfig, type HslBusesConfig } from './config';

export default function useHslBusesConfig(): HslBusesConfig {
  const { data: resolved } = useDashboardWidgets();
  return useMemo(() => {
    const entry = resolved?.find((r) => r.id === 'hsl-buses');
    const stored = (entry?.doc?.config as Partial<HslBusesConfig> | undefined) ?? null;
    return stored ? mergeHslBusesConfig(stored) : DEFAULT_HSL_BUSES_CONFIG;
  }, [resolved]);
}
